import { SavedVolumeType } from 'src/hooks/savedVolume/types';
import { SavedVolumeActionTypes } from './actionTypes';

export type SavedVolumesState = {
  locations: Record<string, SavedVolumeType | null>;
};

export const initialSavedVolumesState: SavedVolumesState = {
  locations: {},
};

export const savedVolumesReducer = (
  state: SavedVolumesState = initialSavedVolumesState,
  action: any
): SavedVolumesState => {
  switch (action.type) {
    case SavedVolumeActionTypes.SET_SAVED_VOLUME: {
      const { location, volume } = action.payload;
      return {
        ...state,
        locations: {
          ...state.locations,
          [location]: volume,
        },
      };
    }
    default:
      return state;
  }
};
